module.exports = __webpack_public_path__ + "img/hnm.d1f51913.svg";